/**
 * src/components/pages/InitialPage.js
 * 
 * Página inicial
 */

import { define, c } from '@components/Component.js'
import { h } from '@core/dom.js'

define('InitialPage', () => {
    return h('div', { className: 'page page--initial' },
        c('Header'),
        c('Promos'),
        c('CategoryStrip'),
        c('FeaturedBusinesses'),
        c('Footer')
    )
})